import {z} from 'zod';

import {depositDefaultPaymentTypeSchema} from './depositDefaultPaymentTypeSchema';
import {depositMethodSchema} from './depositMethodSchema';
import {validateDepositMethodFields} from './validateDepositMethodFields';

// `documentSeriesId` is the canonical name of the deposit document series inside the form. The
// service order API spells the same field `documentSerieId`, which is translated in that module's
// patch body builder instead of leaking two names into the shared form.
export const depositSchema = z
  .object({
    allowDeposit: z.boolean(),
    templateId: z.string().nullish(),
    documentSeriesId: z.string().nullish(),
    defaultPaymentType: depositDefaultPaymentTypeSchema.nullish(),
    cashPayment: depositMethodSchema,
    cardPayment: depositMethodSchema,
    bankPayment: depositMethodSchema,
  })
  .superRefine((data, ctx) => {
    if (!data.allowDeposit) {
      return;
    }

    validateDepositMethodFields('cashPayment', data.cashPayment, ctx);
    validateDepositMethodFields('cardPayment', data.cardPayment, ctx);
    validateDepositMethodFields('bankPayment', data.bankPayment, ctx);
  });

export type DepositFormValues = z.infer<typeof depositSchema>;
